import React, { Component } from 'react';
import $ from 'jquery';
import DataTablesCreate from "./DataTablesCreate";

let headers = [
    { title: 'Código' },
    { title: 'Nombre' },
    { title: 'Stock' },
    { title: 'Comprometido' },
    { title: 'Solicitado' },
    { title: 'Disponible' }
];

class AlmacenModal extends Component {
    componentDidMount() {
        this.closeAction();
    }

    closeAlmacen = async () => {
        $('#almacenDocumentsModal').modal('hide');
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#almacenDocumentsModal').on('hidden.bs.modal', function () {
            //console.log("cerrar Almacen");
            cleanData();
        });
    };


    render() {
        const { data, selectAlmacen, itemSelected, view } = this.props;
        let showStock = (view === 'quotations' || view === 'invoice' || view === 'creditNote' || view === 'orderSales' || view === 'deliveries' || view === 'PurchaseRequest' || view === 'PurchaseOrder' || view === 'GoodsReceipt' || view === 'purchaseReturn' || view === 'purchaseInvoice' || view === 'purchaseCreditNotes' || view === 'invoiceAuthorization' || view === 'invoiceBorrador' || view === 'invoiceReserve' || view === 'transfersEntry' || view === 'transfersOutput' || view === 'transfersRequest' || view === 'transfers') ? true : false;
        if (data.length === 0) {
            return <div className="modal fade bd-example-modal-lg bgtransparent" role="dialog" id="almacenDocumentsModal"></div>;
        }


        return (
            <div>
                <div className="modal fade bd-example-modal-lg modal-open scroll" role="dialog" id="almacenDocumentsModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-open" role="document" >
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                                <h4 className="modal-title" id="modal-basic-title ">Lista de almacenes {itemSelected && `para el artículo (${itemSelected})`}</h4>
                                <button type="button" className="close" onClick={this.closeAlmacen} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body" >
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div className="w-100 table-scroll tab-pane fade show active " aria-labelledby="nav-home-tab-Contenido" >
                                                <table className="table response" style={{ marginBottom: 0, height: 570, maxHeight: 570 }}>
                                                    <tbody>
                                                        <DataTablesCreate
                                                            data={data}
                                                            headers={headers}
                                                            view={"warehouseModal"}
                                                            action={selectAlmacen}
                                                            showStock={showStock}
                                                        />
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeAlmacen}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AlmacenModal;